import axios from 'axios'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

const Logout: React.FC = () => {
	const { t } = useTranslation()
	const router = useRouter()

	axios
		.post(process.env.NEXT_PUBLIC_LOGOUT_ROUTE as string)
		.then(() => {
			if (typeof window !== 'undefined') {
				window.localStorage.removeItem('profile')
				window.localStorage.removeItem('token')
				window.localStorage.removeItem('login-date')
				// window.location.href = `/${locale}/jobs`

				if (
					router.query.isVCF === '1'
				) {
					// Get event landing URL from query or redirect to home
					const eventLandingUrl = router.query.eventLandingUrl as string
					router.replace(eventLandingUrl || '/')
				} else {
					if (typeof router.query.redirect !== 'undefined')
						router.replace(router.query.redirect as string)
					else router.replace('/')
				}
			}
		})
		.catch(() => null)
	return (
		<>
			<div>
				<p className="text-center mt-3">{t('logging_out')}</p>
			</div>
		</>
	)
}

export async function getStaticProps({ locale }) {
	return {
		props: {
			...(await serverSideTranslations(locale, ['common'])),
			// Will be passed to the page component as props
		},
	}
}

export default Logout
